import * as yup from 'yup';

export default yup.object().shape({
  label: yup
    .string()
    .required()
    .max(32)
    .matches(/^[a-zA-Z0-9 ]*$/, 'Is not in correct format'),
});
